import { render, staticRenderFns } from "./ListCampaign.vue?vue&type=template&id=36a7a169&scoped=true&"
import script from "./ListCampaign.vue?vue&type=script&lang=js&"
export * from "./ListCampaign.vue?vue&type=script&lang=js&"
import style0 from "./ListCampaign.vue?vue&type=style&index=0&id=36a7a169&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7a169",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSimpleCheckbox,VTooltip})
